import { handleActions } from 'redux-actions';
import endpoints from '../../../config/endpoints';
import { LOCATION_CHANGE, replace } from 'react-router-redux';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import moment from 'moment';
import qs from 'qs';

import cloneDeep from 'lodash/cloneDeep';
import { getFormValues } from 'redux-form';

import createFilters from '../../shared/fixed-filters';

import {default as createCalendar, getDateRangeFromCalendar} from '../../shared/calendar';

import { createSelectOptionsFromSysEnums } from '../../shared/form-elements/select';
import {regions} from '../../../../../../enums/regions';

const calendar = createCalendar({
	namespace: 'payoutRequestHistory',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(1, 'month').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const filters = createFilters({
	namespace: 'topAffiliatesList',
	stateNodeName: 'filters',
	queryBuildFunc: () => '',
	listOfFilters: [
		{
			name: 'admins',
			title: 'Manager name',
			placeholder: 'Manager name',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.ADMINS,
				params: 'only_managers=true&limit=100&is_show_name=true'
			}
		},
		{
			name: 'affiliates',
			title: 'Affiliates',
			placeholder: 'Add affiliates',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.AFFILIATE_IDS
			}
		},
		{
			name: 'offers',
			title: 'Offers',
			placeholder: 'Add offers',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.OFFERS
			}
		},
		{
			name: 'country_ids',
			title: 'Countries',
			placeholder: 'Add country',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.LOCATIONS_WITH_TRAFFIC,
				params: 'limit=100'
			}
		},
		{
			name: 'niches',
			title: 'Niches',
			placeholder: 'Select niches',
			value: [],
			multi: true,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'dynamic',
				source: endpoints.LOOKUPS.OFFERS_NICHES
			}
		},
		{
			name: 'regions',
			title: 'Regions',
			placeholder: 'Add regions',
			value: [],
			multi: true,
			searchable: false,
			shouldInverse: false,
			shouldShowInverseControl: false,
			options: {
				type: 'provided',
				source: regions.map(reg => ({
					value: reg,
					label: reg
				}))
			}
		}
	]
});

// action types
const FETCH_DATA_SUCCESS = 'payoutRequestHistoryHistory/fetch-data-success';
const FETCH_DATA_ERROR = 'payoutRequestHistoryHistory/fetch-data-error';

const FETCH_SUGGEST_ERROR = 'payoutRequestHistoryHistory/fetch-suggest-error';

const TOGGLE_PROGRESS_BAR = 'payoutRequestHistoryHistory/toggle-progress-bar';

const TOGGLE_SORT = 'payoutRequestHistoryHistory/TOGGLE_SORT';

const APPLY = 'payoutRequestHistoryHistory/apply';

const REQUEST_SUCCESS = 'payoutRequestHistoryHistory/REQUEST_SUCCESS';
const REQUEST_ERROR = 'payoutRequestHistoryHistory/REQUEST_ERROR';

// permissions
export const allowedPermissions = {
	payout_requests_personal_view: 'payout_requests_personal_view',
	payout_requests_view_all: 'payout_requests_view_all',
	payout_requests_review: 'payout_requests_review',
	payout_requests_view_matrix_and_history: 'payout_requests_view_matrix_and_history',
	payout_requests_manager_role: 'payout_requests_manager_role',
	payout_requests_confirm: 'payout_requests_confirm'
};

const table = {
	columns: {
		id: { index: 'id', className: 'short-id-col', title: 'ID', canBeSorted: true },
		created_at: { index: 'created_at', className: 'small-cell', title: 'Created at', canBeSorted: true },
		manager: { index: 'manager', className: '', title: 'Manager' },
		aff_geo_country: { index: 'aff_geo_country', className: 'aff-col', title: 'Aff & Off & Geo' },
		has_conversions: {
			index: 'has_conversions',
			className: 'short-col',
			title: '<div><p>Have traffic<p><p>for offer?</p></div>'
		},
		sid_campaign: {
			index: 'sid_campaign',
			className: '',
			title: 'Sid & Campaign ID'
		},
		current_payout: {
			index: 'current_payout', className: 'short-col', title: '<div><p>Current<p><p>payout</p></div>'
		},
		amount: {
			index: 'amount', className: 'short-col', title: '<div><p>Requested<p><p>payout</p></div>'
		},
		garant_percent: {
			index: 'garant_percent',
			className: 'short-col',
			title: '<div><p>Garant<p><p>approve, %</p></div>'
		},
		traffic_source: { index: 'traffic_source', className: '', title: 'Traffic source' },
		planned_volume: {
			index: 'planned_volume', className: 'short-col',
			title: '<div><p>Planned<p><p>volume</p></div>'
		},
		payout_decision: { index: 'payout_decision', className: 'short-col', title: 'Payout decision' },
		granted_volume: { index: 'granted_volume', className: 'short-col', title: 'Granted volume' },
		comment: { index: 'comment', className: '', title: 'Comment' },
		analytic_comment: { index: 'analytic_comment', className: '', title: 'Analytic comment' },
		status: { index: 'status', className: '', title: 'Status' }
	},
	sortByColumn: {
		index: null,
		direction: null
	}
};
// initial state
const initialState = {
	data: null,
	systemBalances: {},
	calendar: calendar.initialState,
	table,
	showProgressBar: false,
	filters: filters.initialState,
	error: false,
	isRequestFormVisible: false,
	sortedPayoutSystemsList: []
};

// actions
export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			const { calendar, filters: { selectedFilters } } = getState().payoutRequestHistory;

			const query = {
				filters: {}
			};

			if (selectedFilters) {
				selectedFilters.forEach(filter => {
					const values = filter.value.map(f => f.value);
					if (values.length) {
						query.filters[filter.name] = values;
					}
				});
			}

			query.date_range = getDateRangeFromCalendar(calendar);
			query.sort = selectors.getSortByColumn(getState());

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.HISTORY}?${qs.stringify(query)}`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},

		apply: () => (dispatch, getState) => {
			dispatch(actions.fetchData());
		},

		clear: () => (dispatch, getState) => {
			dispatch(replace('/payouts/'));
		},

		toggleSort: (col) => dispatch => {
			if (!col) {
				return;
			}
			dispatch({ type: TOGGLE_SORT, payload: col });
			dispatch(actions.fetchData());
		},
		markRisked: (id) => (dispatch, getState) => {
			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/${id}/risky`,
				method: 'put',
				actions: [REQUEST_SUCCESS, REQUEST_ERROR]
			})(dispatch)
				.then(action => {
					if (action.type === REQUEST_SUCCESS) {
						dispatch(actions.fetchData());
					}
				});
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	calendar.actions,
	filters.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				showProgressBar: false,
				error: false
			};
		},
		[APPLY]: (state, action) => {
			return {
				...state,
				selectedFilters: {
					...action.payload
				}
			};
		},
		[FETCH_DATA_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
		[FETCH_SUGGEST_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[TOGGLE_SORT]: (state, action) => ({
			...state,
			table: {
				...state.table,
				sortByColumn: {
					...state.table.sortByColumn,
					index: action.payload,
					direction: action.payload === state.table.sortByColumn.index &&
						state.table.sortByColumn.direction === 'asc' ? 'desc' : 'asc'
				}
			}
		})
	},
	calendar.reducers,
	filters.reducers
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.payoutRequestHistory.data,
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.payoutRequestHistory.calendar, state => state
	)(state),
	getProgressBar: state => state.payoutRequestHistory.showProgressBar,
	getCreatePayoutRequestForm: state => getFormValues('createPayoutRequestForm')(state),
	getTable: state => {
		const { table, data } = state.payoutRequestHistory;

		const rows = (data || []).map(item => ({
			...item,
			created_at_date: moment(item.created_at).format('DD-MM-YYYY'),
			created_at_time: moment(item.created_at).format('HH:mm:ss')
		}));

		return {
			headers: Object.values(table.columns),
			rows: rows
		};
	},
	getIsRequestFormVisible: state => state.payoutRequestHistory.isRequestFormVisible,
	getSortByColumn: state => state.payoutRequestHistory.table.sortByColumn,
	getIntl: state => intl(state),
	getTrafficSources: state => createSelectOptionsFromSysEnums(state.root.lists['traffic-sources']),
	getCan: state => checkPermissions(state, allowedPermissions),
	getFilters: state => filters.selectors.getFilters(
		state => state.payoutRequestHistory.filters,
		state => state
	)(state),
	getRequestFormInitialValues: state => ({
		currency: 'usd'
	}),
	getError: state => state.payoutRequestHistory.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/request-history/index.js